<template>
  <BaseCard>
    <div class="tw:flex tw:flex-col tw:md:flex-row tw:justify-between tw:text-gray-800 tw:mb-8">
      <div v-if="loading">
        <div class="tw:animate-pulse tw:bg-gray-300 tw:rounded tw:w-full tw:h-80" aria-hidden="true" />
      </div>
      <div v-else class="tw:flex tw:justify-between tw:w-full tw:flex-col">
        <div>
          <p class="tw:text-xl tw:font-bold">{{ $t('form.info.tab_profile_settings') }}</p>
          <div class="tw:flex">
            <span class="required-info tw:text-xs tw:text-gray-700" v-html="$t('required_information')" />
          </div>
        </div>
        <ResetPassword :email="user.email" />
        <PersonalInformationForm :is-onboarding="false" :profile="user" :loading="loading" />
      </div>
    </div>
  </BaseCard>
</template>
<script setup>
import BaseCard from '@/components/dashboard/BaseCard.vue'
import ResetPassword from './ResetPassword.vue'
import PersonalInformationForm from '@/components/onboarding/PersonalInformationForm.vue'

defineProps({
  user: Object,
  loading: Boolean,
})
</script>
<style scoped>
.required-info :deep(span) {
  color: var(--tw-color-red-700);
}
</style>
